export default class {
  constructor($el) {
    this.$el = $el;
    this.$question_container = $el.find('[data-quesiton-container]');
    this.$answer_container = $el.find('[data-answer-container]');
    this.$answer = $el.find('[data-answer]');

    this.handleQuestionClick = this.handleQuestionClick.bind(this);

    this.$question_container.on('click', this.handleQuestionClick);
  }

  handleQuestionClick() {
    if (this.$el.hasClass('FAQ__qa-block--expanded')) {
      const $answer_container = this.$el.find('[data-answer-container]');
      this.$el.removeClass('FAQ__qa-block--expanded');
      $answer_container.css('max-height', '0px');
    } else {
      this.$el.parent().children('[data-qa-block]').removeClass('FAQ__qa-block--expanded');
      this.$el.addClass('FAQ__qa-block--expanded');

      this.$el.parent().children('[data-qa-block]').each((i, item) => {
        const $item = $(item);
        const $answer_container = $item.find('[data-answer-container]');
        const $answer = $item.find('[data-answer]');

        if ($item.hasClass('FAQ__qa-block--expanded')) {
          const answer_height = $answer.height();
          $answer_container.css('max-height', `${answer_height}px`);
        } else {
          $answer_container.css('max-height', '0px');
        }
      });
    }
  }
}
